import { ConfirmSignIn } from 'aws-amplify-react';

import { renderStockScreen } from './stock-screen';
import { stripRequiredMarks } from './strip-required-marks';

/**
 * The stock Amplify v3 Confirm SMS Code screen (shown when MFA is switched on
 * for an account), with the required-field asterisk dropped so it matches the
 * rest of the auth screens.
 */
export class LabSmartsConfirmSignIn extends ConfirmSignIn {
  showComponent(theme: any): JSX.Element {
    return stripRequiredMarks(
      renderStockScreen(this, ConfirmSignIn, () => super.showComponent(theme)),
    ) as JSX.Element;
  }
}
